export const AUTH_USER = 'AUTH_USER';
export const UNAUTH_USER = 'UNAUTH_USER';

export const API_INFO = 'API_INFO';
export const API_SUCCESS = 'API_SUCCESS';
export const API_WARNING = 'API_WARNING';
export const API_ERROR = 'API_ERROR';
export const API_OAUTH_IN_PROGRESS = 'API_OAUTH_IN_PROGRESS';

export const FETCH_USER = 'FETCH_USER';
export const UPDATE_PROFILE = 'UPDATE_PROFILE';